import Papa from 'papaparse'
import api from '@/api'

if (!FormData.fromObject) {
    FormData.fromObject = function objectToFormData(obj) {
        const formData = new FormData()

        function appendToFormData(formData, value, key) {
            var valueType = typeof value
            if (valueType === 'function' || value == null) {
                return
            }

            if (Array.isArray(value) && value.all((v) => v instanceof File)) {
                value.forEach((item) => {
                    appendToFormData(formData, item, key)
                })
                return
            }

            if (value instanceof Date) {
                value = value.toLocaleDateString('en-US')
                formData.append(key, value)
                return
            }
            if (valueType === 'object' && !(value instanceof File)) {
                convertObjectPropertiesToFormData(formData, value, key)
                return
            }
            formData.append(key, value)
        }

        function convertObjectPropertiesToFormData(formData, obj, namespace) {
            for (let property in obj) {
                const formKey = buildFormKey(namespace, property, obj)
                appendToFormData(formData, obj[property], formKey)
            }
        }

        function buildFormKey(namespace, property, value) {
            if (!namespace) {
                return property
            }

            if (Array.isArray(value)) {
                return `${namespace}[${property}]`
            }
            return `${namespace}.${property}`
        }

        convertObjectPropertiesToFormData(formData, obj)

        return formData
    }
}

if (!FormData.prototype.appendArray) {
    FormData.prototype.appendArray = function (key, array) {
        if (array == null) {
            return
        }

        if (!Array.isArray(array)) {
            throw 'appendArray requires an array as argument'
        }

        array.forEach((item) => {
            this.append(key, item)
        })
    }
}
